import styled from '@emotion/styled';
import { affordabilityExcludedColors, fraudAndComplianceColors } from 'src/assets/colors';
import { TablePropsType, TableWrapperTemplate, TableHeaderRowTemplate, TableRowTemplate, ColumnHeaderTemplate, TableCellTemplate, SectionMessageTemplate } from 'src/components/FraudAndCompliance/FraudAndCompliancesTab/FraudAndCompliances/components/CommonTable.styles';
import { ChevronDownIcon } from 'src/assets/icons/ChevronDownIcon';
import WarningIcon from 'src/assets/icons/WarningIcon';

export const AffordabilityExcludedContainer = styled('div', { label: 'AffordabilityExcludedContainer' })`
    flex: 1 1 0%;
    height: calc(100vh - 56px);
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0 24px 24px 24px;
`;

export const SectionHeader = styled('h2', { label: 'SectionHeader' })`
    font-size: 16px !important;
    color: ${fraudAndComplianceColors.withdrawalReqColors.txtColor};
    margin: 0 0 12px !important;
`;

export const SectionMessage = styled(SectionMessageTemplate, { label: 'SectionMessage' })``;

export const TableWrapper = styled(TableWrapperTemplate, { label: 'TableWrapper' })``;

export const TableHeaderRow = styled(TableHeaderRowTemplate, { label: 'TableHeaderRow' })``;

export const TableRow = styled(TableRowTemplate, { label: 'TableRow' }) <TablePropsType>`
    height: 50px;
`;

export const ColumnHeader = styled(ColumnHeaderTemplate, { label: 'ColumnHeader' })`
`;

export const TableCell = styled(TableCellTemplate, { label: 'TableCell' })<{ cellWidth : number, isClickable: boolean }>`
    width: ${({ cellWidth }): string => cellWidth !== null ? `${cellWidth}%` : 'auto' } !important;
    padding: 14px 14px !important;
    cursor: ${({ isClickable }): string => isClickable === true ? 'pointer' : 'default' };
`;

export const TabWrapper = styled('div', { label: 'TabWrapper' })`
    width: 100%;
    height: auto;
    padding: 15px 0 33px 0;
    font-family: sans-serif;
    color: ${affordabilityExcludedColors.mainColor};
`;

export const UlInline = styled('ul', { label: 'UlInline' })`
    display: flex;
    margin: 0 0 0 25px;
    width: 100%;
    list-style: none;
    padding: 0;
    margin-bottom: 0;
`;

export const ParticularLi = styled('ul', { label: 'ParticularLi' })<{ isSelected : boolean }>`
    flex-direction: row;
    margin-left: 0;
    border-bottom: 5px solid ${({ isSelected }): string => isSelected ? affordabilityExcludedColors.borderBottomColorSelected : affordabilityExcludedColors.oddTableColor }; 
    transition: ${({ isSelected }): string => isSelected ? 'none' : 'all 0.5s' };
    font-family: Lato, sans-serif;
    font-weight: 300;
    cursor: pointer;
    color: ${({ isSelected }): string => isSelected ? affordabilityExcludedColors.mainColor : affordabilityExcludedColors.liColor };
    font-weight: bold;
`;

export const PaginationElements = styled('ul', { label: 'PaginationElements' })`
   display: flex;
   flex-direction: row;
   align-items: center;
   padding-left: 25px;
   cursor: pointer;
   list-style: none;
   margin: 0;
`;

export const ParticularNumber = styled('li', { label: 'ParticularNumber' })<{ isSelected : boolean }>`
    border-radius: 6px;
    border: 2px solid ${affordabilityExcludedColors.borderBottomColorSelected};
    color:  ${({ isSelected }): string => isSelected ? affordabilityExcludedColors.evenTableColor : affordabilityExcludedColors.borderBottomColorSelected }; 
    background-color: ${({ isSelected }): string => isSelected ? affordabilityExcludedColors.borderBottomColorSelected : 'transparent' }; 
    font-weight: bold;
    font-size: 14px;
    padding: 2px 10px 2px 10px;
    margin: 5px;

`;

export const ChevronLeftWrapper = styled(ChevronDownIcon, { label: 'ChevronLeftWrapper' })`
    fill: ${affordabilityExcludedColors.mainColor};
    transform: rotate(90deg);
    margin: 13px 8px;
    right: 5px;
    width: 12px;
    height: 12px;
    top: 0;
`;

export const ChevronRightWrapper = styled(ChevronDownIcon, { label: 'ChevronRightWrapper' })`
    fill: ${affordabilityExcludedColors.mainColor};
    transform: rotate(-90deg);
    margin: 13px 8px;
    right: 5px;
    width: 12px;
    height: 12px;
    top: 0;
`;

export const ReasonWrapper = styled('div', { label: 'ReasonWrapper' })`
   display: flex;
   flex-direction: row;
`;

export const ReasonItem = styled('p', { label: 'ReasonItem' })`
   overflow-wrap: anywhere;
`;

export const ReasonShow = styled('p', { label: 'ReasonShow' })`
   color: ${affordabilityExcludedColors.borderBottomColorSelected};
   font-weight: bold;
   cursor: pointer;
`;

export const Header = styled('h1', { label: 'Header' })`
    margin-top: 32px;
    font-size: 24px;
`;

export const StatusWrapper = styled('div', { label: 'StatusWrapper' })<{ color : string }>`
    border-radius: 4px;
    font-weight: bold;
    margin: -5px 0 0 -5px;
    padding: 4px 8px 4px 8px;
    width: fit-content;
    color: ${({ color }): string => {
        if (color === 'Red') {
            return `${affordabilityExcludedColors.txtColor}`;
        } else if (color === 'Amber') {
            return affordabilityExcludedColors.txtColorSecondary;
        } else if ( color === 'Green') {
            return affordabilityExcludedColors.txtColorTertiary;
        } else {
            return affordabilityExcludedColors.txtColorQuaternary;
        }
    }};
    background-color: ${({ color }): string => {
        if (color === 'Red') {
            return `${affordabilityExcludedColors.bgColor}`;
        } else if (color === 'Amber') {
            return affordabilityExcludedColors.bgColorSecondary;
        } else if ( color === 'Green') {
            return affordabilityExcludedColors.bgColorTertiary;
        } else {
            return affordabilityExcludedColors.bgColorQuaternary;
        }
    }} !important;
`;

export const ActionSelect = styled('div', { label: 'ActionSelect' })`
    width: fill-available;
    height: fill-available;
    margin: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    font-family: inherit;
    font-size: 12px;
    transition: all 150ms ease;

    &:focus {
        outline: none;
    }
`;

export const DropdownActionPlaceholder = styled('div', { label: 'DropdownActionPlaceholder' })`
    width: fill-available;
    margin: -14px;
    padding: 14px;
    position: relative;
    background: transparent;
    color: ${affordabilityExcludedColors.txtColorQuaternary}; 
    font-size: 12px;
`;

export const DropdownUL = styled('ul', { label: 'DropdownUL' })`
    position: absolute;
    margin: 0;
    padding: 0;
    border-radius: 4px !important;
    overflow:hidden;
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
    font-weight: bold;
`;

export const DropdownULAction = styled('ul', { label: 'DropdownULAction' })`
    position: absolute;
    padding: 0;
    border-radius: 4px !important;
    overflow:hidden;
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
    font-weight: bold;
    z-index: 10000;
    margin-left: -14px;
    margin-top: 18px;
    width: 100%;
`;
    
export const LiNotSelectedAction = styled('li', { label: 'LiNotSelectedAction' })`
    position: relative;
    padding: 4px 8px 4px 8px;
    width: fill-available;
    height: 32px;
    font-size: 12px;
    background: ${affordabilityExcludedColors.oddTableColor}; 
    cursor: pointer;
    list-style: none;
    z-index: 10000;
    display: flex;
    align-items: center;
`;

export const LiNotSelected = styled('li', { label: 'LiNotSelected' })`
    position: relative;
    padding: 4px 8px 4px 8px;
    width: 180px;
    height: 32px;
    font-size: 12px;
    background: ${affordabilityExcludedColors.evenTableColor};
    max-width: 300px;
    cursor: pointer;
    list-style: none;
    z-index: 10000;
`;

export const LiSelected = styled('li', { label: 'LiSelected' })`
    position: relative;
    padding: 4px 8px 4px 8px;
    width: 180px;
    height: 32px;
    font-size: 12px;
    background: ${affordabilityExcludedColors.evenTableColor};
    max-width: 300px;
    cursor: pointer;
    list-style: none;
    z-index: 10000;    

    background: ${affordabilityExcludedColors.mainColorSecondary};

`;

export const DropdownPlaceholder = styled('div', { label: 'DropdownPlaceholder' })`
    position: relative;
    background: transparent;
    border: 1px solid ${affordabilityExcludedColors.mainColorQuaternary};
    width: 180px;
    height: 32px;
    padding: 6px;
    border-radius: 4px;
    max-width: 300px;   
    font-size: 12px;
    display: flex;
    align-items: center;
`;

export const Dropdown = styled('div', { label: 'Dropdown' })`
    margin: 5px;
    cursor: pointer;
`;

export const DropdownWrapper = styled('div', { label: 'DropdownWrapper' })`
    display: flex;
`;

export const ChevronDownWrapper = styled(ChevronDownIcon, { label: 'ChevronDownWrapper' })`
    fill: ${affordabilityExcludedColors.txtColorQuaternary};
    margin: 8px 8px;
    right: 6px;
    position: absolute;
    pointer-events: none;
`;

export const AlertBox = styled('div', { label: 'AlertBox' })`
    background: rgb(0 0 0 / 0.2);
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
    height: 100%;
    width: 100%;
    border-radius: 4px;

`;

export const AlertMessage = styled('div', { label: 'AlertMessage' })`
    background: ${affordabilityExcludedColors.evenTableColor};
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 101;
    height: 296px;
    width: 384px;
    border-radius: 4px;
`;

export const ModalHeader = styled('div', { label: 'ModalHeader' })`
    postion: relative;
    background: ${affordabilityExcludedColors.mainColorTertiary};
    height: 48px;
    width: 384px;
    top: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    font-weight: bold;
    padding-left: 16px;
    padding-right: 5px;
    border-radius: 4px 4px 0 0;
`;

export const ModalBody = styled('div', { label: 'ModalBody' })`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ModalLabel = styled('p', { label: 'ModalLabel' })`
    word-wrap: break-word;
    text-align: center !important;
    padding: 0 16px 0 16px;
    margin-bottom: auto;
    font-weight: bold;
`;

export const ModalLabelDanger = styled('p', { label: 'ModalLabelDanger' })`
    color: ${affordabilityExcludedColors.evenTableColor};
    padding-left: 8px;
    font-size: 14px;
    font-weight: bold;
`;

export const WarningIconWrapper = styled(WarningIcon, { label: 'WarningIconWrapper' })`
    fill: ${affordabilityExcludedColors.txtColor};
    height: 38px;
    width: 43px;
    margin-top: 25px;
`;

export const CheckboxDangerWrapper = styled('div', { label: 'CheckboxDangerWrapper' })`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    background-color: ${affordabilityExcludedColors.txtColor};
    border-radius: 4px;
    width: 225px;
    height: 32px;
    padding-left: 14px;
    white-space: nowrap;
`;

export const CloseIconWrapper = styled('div', { label: 'CloseIconWrapper' })`
    cursor: pointer;
`;
